module.exports = __webpack_public_path__ + "img/ehe_logo.42365363.png";